// Curated hero imagery per state.
//
// Lived inside ChooseCluster.jsx until the Final Itinerary hero needed the same
// pictures; shared here so the two pages (and the public shared-trip view)
// cannot drift apart.
//
// A curated photograph beats whatever Google Places returns for a state name,
// so these are preferred and the Google lookup is the fallback — not the other
// way round. See GooglePlaceImage, which only reaches for Google when its
// `fallbackSrc` is absent or fails to load.

/** Full-bleed hero shots on R2. */
export const STATE_R2_IMAGES = {
  Delhi: "https://pub-07733e81cacb4a51b2e3f1282ec8e360.r2.dev/clusters/Delhi/Delhi%20main.jpg",
  Goa: "https://pub-07733e81cacb4a51b2e3f1282ec8e360.r2.dev/clusters/Goa/Goa%20Main%20.jpg",
  "Himachal Pradesh": "https://pub-07733e81cacb4a51b2e3f1282ec8e360.r2.dev/clusters/Himachal%20Pradesh/Himachal%20Main.jpg",
  Uttarakhand: "https://pub-07733e81cacb4a51b2e3f1282ec8e360.r2.dev/clusters/Uttarakhand/Uttrakhand%20main.jpg",
  Kerala: "https://pub-07733e81cacb4a51b2e3f1282ec8e360.r2.dev/clusters/Kerala/kerala%20main.jpg",
  "Tamil Nadu": "https://pub-07733e81cacb4a51b2e3f1282ec8e360.r2.dev/clusters/Tamil%20Nadu/Tamil%20Nadu.jpg",
  Rajasthan: "https://pub-07733e81cacb4a51b2e3f1282ec8e360.r2.dev/clusters/Rajasthan/Rajasthan%20Main.jpg",
};

/**
 * Bundled 800px-wide JPGs, 46-100KB each.
 *
 * These deliberately point at the .jpg files, not the .png ones this map used
 * to name. The PNGs are card thumbnails (390x260) that are both too small for a
 * hero and *heavier* than the JPGs — Kerala was a 228KB PNG at 390px where the
 * JPG is 74KB at 800px — and "/destinations/tamil-nadu.png" does not exist at
 * all, so that entry was a 404.
 */
export const STATE_COVER_IMAGES = {
  Delhi: "/destinations/delhi.jpg",
  Goa: "/destinations/goa.jpg",
  "Himachal Pradesh": "/destinations/himachal.jpg",
  Uttarakhand: "/destinations/uttarakhand.jpg",
  Kerala: "/destinations/kerala.jpg",
  "Tamil Nadu": "/destinations/tamil-nadu.jpg",
  Rajasthan: "/destinations/rajasthan.jpg",
};

/** Former name, kept so existing callers keep working. */
export const STATE_FALLBACK_IMAGES = STATE_COVER_IMAGES;

/**
 * Full-resolution R2 shot for a state, or `null` when we have none.
 *
 * For large heroes only: these are the original photographs, 1.8MB-5.4MB each,
 * and the R2 bucket has no image-resizing endpoint (/cdn-cgi/image 404s). Use
 * getStateCoverImage for anything smaller.
 *
 * Null matters: only seven states are covered, and returning some other state's
 * photograph for an uncovered one is worse than returning nothing — callers
 * pass null to GooglePlaceImage, which then resolves a picture of the actual
 * destination.
 */
export function getStateHeroImage(stateName) {
  return STATE_R2_IMAGES[stateName] || STATE_COVER_IMAGES[stateName] || null;
}

/** Lightweight cover for modest heroes and cards. Null when uncovered. */
export function getStateCoverImage(stateName) {
  return STATE_COVER_IMAGES[stateName] || null;
}
